import { useEffect, useState } from 'react'

export const useWindowSize = (debounceMs = 500) => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  useEffect(() => {
    let timeout: NodeJS.Timeout
    const handler = () => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        setSize({
          width: window.innerWidth,
          height: window.innerHeight,
        })
      }, debounceMs)
    }
    window.addEventListener('resize', handler)
    return () => {
      window.removeEventListener('resize', handler)
      clearTimeout(timeout)
    }
  }, [debounceMs])

  return size
}
